import { AxiosResponse } from 'axios';
import { NextApiRequest, NextApiResponse } from 'next';
import {
  SingleIdProfileAndVehicleRequest,
  SingleIdResponse,
  SingleIdTransactionResponse,
  SubmitModalSingleIdRequest,
  IPayloadDMCPVehilces,
} from '../interface/login-modal.interface';
import {
  SingleIdAccountListResponse,
  submitAccountVerificationPayload,
} from '../interface/singleid.interface';
import api from './api';
import { APIProxy } from './api-proxy';

export const getSingleId = async (): Promise<SingleIdResponse> => {
  const res = await api.get('/api/get-singleid', {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });

  return res?.data;
};

export const getAutoSeamless = async (req: NextApiRequest, res: NextApiResponse) => {
  try {
    const apiProxy = new APIProxy(req, res);

    const myCookie = req.headers.cookie;
    if (myCookie) {
      let type = '';
      if (typeof req.query.type === 'string') {
        type = req.query.type;
      }
      const cookies = Object.fromEntries(
        myCookie
          ?.split(';')
          .map((cookie) => cookie.trim().split('='))
          .map(([key, value]) => [key, decodeURIComponent(value)]) || []
      );
      switch (type) {
        case 'transaction': {
          if (req.method !== 'GET') {
            res.status(400).json(null);
            return;
          }
          const responseAutoSeamless = await apiProxy.makeRequest({
            method: req.method,
            url: 'saphybris-proxy/v1/saphybris/single-id/account-list-tdms',
            headers: {
              Authorization: `Bearer ${cookies?.['access-token']}`,
            },
            params: {
              ...(req?.query?.isDac === 'true' && {
                isDac: true,
              }),
            },
          });
          res.status(200).json(responseAutoSeamless.data);
          break;
        }
        case 'profile': {
          if (req.method !== 'POST') {
            res.status(400).json(null);
            return;
          }
          const responseProfile = await apiProxy.makeRequest({
            method: req.method,
            url: 'saphybris-proxy/v1/saphybris/single-id/vehicle-o2o',
            headers: {
              Authorization: `Bearer ${cookies?.['access-token']}`,
            },
            data: req.body,
          });
          res.status(200).json(responseProfile.data);
          break;
        }
        default: {
          if (req.method !== 'GET') {
            res.status(400).json(null);
            return;
          }
          const responseUserCheck = await apiProxy.makeRequest({
            method: req.method,
            url: 'customer/v1/saphybris/customer/single-id',
            headers: {
              Authorization: `Bearer ${cookies?.['access-token']}`,
            },
          });
          res.status(200).json(responseUserCheck.data);
          break;
        }
      }
    } else {
      res.status(401).json(null);
    }
  } catch (error) {
    console.log(error);
    res
      .status(error.status || 500)
      .json(error.response?.data || { error: 'Internal Server Error' });
  }
};

export const getTranscation = async (isDAC = false): Promise<SingleIdTransactionResponse> => {
  try {
    const res = await api.get('/api/get-singleid?type=transaction', {
      baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
      params: {
        ...(isDAC && {
          isDac: true,
        }),
      },
    });

    return res?.data;
  } catch {
    return {
      acknowledge: 0,
      accounts: [],
    } as SingleIdTransactionResponse;
  }
};

export const getProfileAndVehicleO2O = async (
  data?: SingleIdProfileAndVehicleRequest
): Promise<SingleIdResponse> => {
  const res = await api.post('/api/get-singleid?type=profile', null, data, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });

  return res?.data;
};

export const submitModalSingleId = async (req: NextApiRequest, res: NextApiResponse) => {
  const apiProxy = new APIProxy(req, res);
  try {
    if (req.method === 'POST') {
      // Access the HTTP-only cookie from the incoming request

      const body: SubmitModalSingleIdRequest = req.body;

      const myCookie = req.headers.cookie;
      if (myCookie) {
        const cookies = Object.fromEntries(
          myCookie
            ?.split(';')
            .map((cookie) => cookie.trim().split('='))
            .map(([key, value]) => [key, decodeURIComponent(value)]) || []
        );

        const accessToken = cookies?.['access-token'];

        switch (body.type) {
          case 'pdpConsent': {
            const status = body.data.consentStatus;
            const isLogin = body.data?.isLogin;
            const { data: consentData } = await api.post(
              `customer/v1/saphybris/pdp-consent?status=${status}&isLogin=${isLogin}`,
              null,
              null,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            return res.status(200).json(consentData);
          }
          case 'seamless': {
            const seamlessBody = body.data;
            const { data: seamlessData } = await api.post(
              `customer/v1/saphybris/customers/single-id/update-data?customerTDMSNo=${seamlessBody?.customerTDMSNo ?? ''}&alamat=${seamlessBody?.alamat ?? ''}&kota=${seamlessBody?.kota}&nama=${seamlessBody?.nama ?? ''}&nik=${seamlessBody?.nik ?? ''}&pekerjaan=${seamlessBody?.pekerjaan ?? ''}&tanggalLahir=${seamlessBody.tanggalLahir ?? ''}`,
              null,
              null,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            return res.status(200).json(seamlessData);
          }
          case 'o2ocars': {
            const o2oProfileCars = body.data;
            if (
              typeof o2oProfileCars.is020Sync !== 'boolean' ||
              typeof o2oProfileCars.isEmailVerified !== 'boolean' ||
              typeof o2oProfileCars.isPhoneVerified !== 'boolean' ||
              typeof o2oProfileCars.isWAVerified !== 'boolean'
            ) {
              return res.status(400).json({ error: 'Bad Request' });
            }
            const { data: o2oCarsData } = await api.post(
              `customer/v1/saphybris/single-id/update`,
              null,
              {
                isPhoneVerified: o2oProfileCars.isPhoneVerified,
                isWAVerified: o2oProfileCars.isWAVerified,
                isEmailVerified: o2oProfileCars.isEmailVerified,
                is020Sync: o2oProfileCars.is020Sync,
                myVehicleList: o2oProfileCars.myVehicleList,
                notMyVehicleList: o2oProfileCars.notMyVehicleList,
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            );
            return res.status(200).json(o2oCarsData);
          }

          case 'declineseamless': {
            const declineBody = body.data;
            const { data: response } = await apiProxy.makeRequest({
              method: req.method!,
              url: `saphybris-proxy/v1/saphybris/single-id/decline?custNoTDMS=${declineBody}`,
              headers: {
                Authorization: 'Bearer ' + accessToken,
              },
              data: req.body,
            });
            return res.status(200).json(response);
          }
          case 'autoseamlessubmit': {
            const autoSeamlessBody = body.data;
            const { data: response } = await apiProxy.makeRequest({
              method: req.method!,
              url: 'saphybris-proxy/v1/saphybris/customers/auto-seamless',
              headers: {
                Authorization: 'Bearer ' + accessToken,
              },
              data: {
                customerNoTDMS: autoSeamlessBody.customerNoTDMS,
                is020Sync: autoSeamlessBody.is020Sync,
                myVehicleList: autoSeamlessBody.myVehicleList,
                notMyVehicleList: autoSeamlessBody.notMyVehicleList,
                dmcpVehicles: autoSeamlessBody.dmcpVehicles || [],
              },
            });
            return res.status(200).json(response);
          }
          default:
            res.status(400).json({ err: 'Wrong Type' });
            break;
        }
      } else {
        res.status(401).json(null);
      }
    } else if (req.method === 'PUT') {
      const body: SubmitModalSingleIdRequest = req.body;
      if (body.type === 'pdpConsentNotLoggedIn') {
        const pdpConsentNotLoggedInData = body.data;
        const { data: dataPdpConsentNotLoggedIn } = await api.put(
          `customer/v1/saphybris/pdp-consent`,
          null,
          { ...pdpConsentNotLoggedInData },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        return res.status(200).json(dataPdpConsentNotLoggedIn);
      } else {
        res.status(400).json({ err: 'Wrong Type' });
      }
    } else {
      res.status(400).json(null);
    }
  } catch (error) {
    console.log(error);
    return res
      .status(error.status || 500)
      .json(error.response?.data || { error: 'Internal Server Error' });
  }
};

const getSingleIdAccountList = async (): Promise<AxiosResponse<SingleIdAccountListResponse>> => {
  const res = await api.post('/api/single-id-account-list', null, null, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });
  return res;
};

const submitAccountVerification = async (payload: submitAccountVerificationPayload) => {
  const res = await api.post('/api/single-id-submit-account', null, payload, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });
  return res;
};

export const submitVehicleDmcp = async (payload: IPayloadDMCPVehilces) => {
  const res = await api.post('/api/submit-vehicles-dmcp', null, payload, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });

  return res;
};

export const submitVehicleDmcpO2O = async (req: NextApiRequest, res: NextApiResponse) => {
  const apiProxy = new APIProxy(req, res);
  try {
    if (req.method !== 'POST') {
      return res.status(405).json({ error: 'Method Not Allowed' });
    }

    const myCookie = req.headers.cookie;
    if (!myCookie) {
      return res.status(401).json(null);
    }

    const cookies = Object.fromEntries(
      myCookie
        .split(';')
        .map((cookie) => cookie.trim().split('='))
        .map(([key, value]) => [key, decodeURIComponent(value)])
    );
    const accessToken = cookies?.['access-token'];

    const { data } = await apiProxy.makeRequest({
      method: req.method,
      url: 'saphybris-proxy/v1/saphybris/confirm-dmcp',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: req.body,
    });

    return res.status(200).json(data);
  } catch (error) {
    return res
      .status(error?.status || 500)
      .json(error?.response?.data || { error: 'Internal Server Error' });
  }
};

export default {
  getSingleId,
  getAutoSeamless,
  getTranscation,
  getProfileAndVehicleO2O,
  submitModalSingleId,
  getSingleIdAccountList,
  submitAccountVerification,
};
